import React from 'react';
import { Link } from 'react-router-dom';
import './WhyUs.css';

function WhyUs() {
  const benefits = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <line x1="12" y1="2" x2="12" y2="6"></line>
          <line x1="12" y1="18" x2="12" y2="22"></line>
          <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
          <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
          <line x1="2" y1="12" x2="6" y2="12"></line>
          <line x1="18" y1="12" x2="22" y2="12"></line>
          <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
          <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
        </svg>
      ),
      title: "Increased Efficiency",
      description: "Save countless hours by automating address entry. What used to take minutes now takes seconds."
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
      ),
      title: "Enhanced Accuracy",
      description: "Eliminate human error in data entry. Our system ensures precise address information every time."
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="23 4 23 10 17 10"></polyline>
          <polyline points="1 20 1 14 7 14"></polyline>
          <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
        </svg>
      ),
      title: "Real-Time Updates",
      description: "Address fields are populated instantly as soon as a ZIP code is entered, keeping your data current."
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
          <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
          <line x1="6" y1="6" x2="6.01" y2="6"></line>
          <line x1="6" y1="18" x2="6.01" y2="18"></line>
        </svg>
      ),
      title: "Seamless Integration",
      description: "Designed specifically for HubSpot, our solution integrates flawlessly with your existing workflow."
    }
  ];

  const features = [
    "Backfilling capability for existing contacts with HubSpot workflows",
    "Support for US ZIP codes and limited Canadian postal codes",
    "Customizable field mapping for City, State, County, and Country",
    "Support for both contact and company records",
    "Automatic timezone population (using the default hs_timezone property)",
    "Pay-as-you-go model with no monthly fees",
    "Secure and compliant with data protection regulations"
  ];

  const businessTypes = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <path d="M16 10a4 4 0 0 1-8 0"></path>
        </svg>
      ),
      type: "E-commerce",
      description: "Ensure accurate shipping addresses"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
      ),
      type: "Real Estate",
      description: "Manage property locations efficiently"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"></path>
          <polyline points="8 10 12 14 16 10"></polyline>
        </svg>
      ),
      type: "Marketing",
      description: "Run geo-targeted campaigns"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
        </svg>
      ),
      type: "Sales",
      description: "Organize territories and leads"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
      ),
      type: "Customer Service",
      description: "Verify customer information quickly"
    }
  ];

  return (
    <div className="why-us-container">
      <div className="why-us-header">
        <div className="header-shapes">
          <div className="header-shape shape1"></div>
          <div className="header-shape shape2"></div>
          <div className="header-shape shape3"></div>
        </div>
        <h1>Why Choose ZipCode AutoFill?</h1>
        <p className="header-tagline">
          Streamline Your Address Management with Unparalleled Efficiency
        </p>
        <p className="header-subtitle">
          ZipCode AutoFill is the smart solution for businesses looking to optimize their HubSpot CRM with accurate, automated address data.
        </p>
      </div>

      <section className="benefits-section">
        <h2>Key Benefits</h2>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div className="benefit-card" key={index}>
              <div className="benefit-icon">{benefit.icon}</div>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="features-section">
        <h2>Features That Set Us Apart</h2>
        <ul className="features-list">
          {features.map((feature, index) => (
            <li key={index}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              {feature}
            </li>
          ))}
        </ul>
        <div className="features-image">
          <img src="/images/features-illustration.svg" alt="ZipCode AutoFill Features" onError={(e) => {
            e.target.onerror = null;
            e.target.style.display = 'none';
          }} />
          <div className="features-bg-shape"></div>
        </div>
      </section>

      <section className="business-types-section">
        <h2>Perfect for Businesses of All Sizes</h2>
        <p className="section-intro">
          Whether you're a small business handling hundreds of contacts or a large enterprise managing thousands, ZipCode AutoFill scales to meet your needs:
        </p>
        <div className="business-types-grid">
          {businessTypes.map((business, index) => (
            <div className="business-type-card" key={index}>
              <div className="business-icon">{business.icon}</div>
              <h3>{business.type}</h3>
              <p>{business.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="testimonial-section">
        <div className="testimonial-card">
          <div className="quote-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10 11h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1z"></path>
              <path d="M21 11h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1z"></path>
            </svg>
          </div>
          <blockquote>
            ZipCode AutoFill has revolutionized my address management process. It's saved me countless hours and significantly reduced errors in our database. I have also seen a significant uptick in form submissions since I was able to cut out many unnecessary fields.
          </blockquote>
          <div className="testimonial-author">
            <img src="/images/avatar-placeholder.png" alt="User avatar" className="author-image" onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="%234361EE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>';
            }} />
            <div className="author-info">
              <p className="author-name">Gian Paul Scorzo</p>
              <p className="author-title">Founder at CARISSIMO</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h2>Ready to Optimize Your HubSpot Experience?</h2>
        <p>Join the businesses already saving time and improving data accuracy with ZipCode AutoFill.</p>
        <div className="cta-buttons">
          <Link to="/register" className="cta-button primary">Get Started Today</Link>
          <Link to="/pricing" className="cta-button secondary">View Pricing</Link>
        </div>
        <div className="cta-shape cta-shape-1"></div>
        <div className="cta-shape cta-shape-2"></div>
      </section>
    </div>
  );
}

export default WhyUs;
